"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextRequestOutputSchema = exports.ContextRequestInputSchema = void 0;
const zod_1 = require("zod");
const result_1 = require("../result");
/**
 *  /api/staffbar/context
 *  ---------------------
 *
 * This endpoint is used to provide context to the bar and to expand the context
 * that the bar has access to.
 *
 */
/**
 * This is the input to the context request
 */
exports.ContextRequestInputSchema = zod_1.z.object({
    meta: zod_1.z.object({
        url: zod_1.z.string(),
    }),
    context: zod_1.z.object({}).passthrough(),
});
/**
 * This is everything we need to build the bar
 */
exports.ContextRequestOutputSchema = zod_1.z.object({
    // Consider passing the bar config here
    providers: zod_1.z.record(zod_1.z.string(), result_1.Result),
});
